/** Sender-only size ceilings. These never change the shared camera or upscale it. */
export class HostResolutionScaling {
  public scale(tier: string, width?: number, height?: number): number | undefined {
    if (tier === 'source') return 1;
    if (!width || !height || width <= 0 || height <= 0) return undefined;
    const ceiling = QUALITY_TIER_RESOLUTION[tier as keyof typeof QUALITY_TIER_RESOLUTION];
    if (!ceiling) return undefined;
    return Math.max(1, width / ceiling.width, height / ceiling.height);
  }
}
import { QUALITY_TIER_RESOLUTION } from '../../webrtcLatencyContracts';
